<template>
  <div class="section" style="height: auto;padding: 20px 20px 10px 20px">
    <div class="triggers" style="margin-bottom: 10px;">
      <el-button
        no="new"
        :disabled="!isEdit"
        type="primary"
        @click="showEditDialog(true)"
      >{{ $t('common.btn.new') }}</el-button>
      <el-button
        no="edit"
        :disabled="!isEdit"
        type="primary"
        @click="showEditDialog(false)"
      >{{ $t('common.btn.edit') }}</el-button>
      <el-button
        no="delete"
        :disabled="!isEdit"
        type="danger"
        @click="remove"
      >{{ $t('common.btn.delete') }}</el-button>
    </div>
    <div class="grid-wrapper" style="flex-grow: 1">
      <cargo-ag-grid
        config-module="100805"
        :wrap-text="true"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="exChangeAgentList"
        style="height: 100%"
      />
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;margin-left: 25px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')" required>
            <cargo-owned-branch-select
              :value="toNumArray(editDialog.form.multipleBranchId)"
              no="multipleBranchId"
              :select-type="selectTypeNames.basic_data_Office_All"
              :static-options="currentOfficeList"
              :multiple="true"
              style="width: 200px;"
              @input="val=>{editDialog.form.multipleBranchId=toTxt(val)}"
              @change="multipleBranchIdChange"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BillExchangeAgent')" required>
            <cargo-advance-select
              no="exChangeAgent"
              :select-type="selectTypeNames.basic_data_Company"
              filterable
              :cache="false"
              :static-options="agentList"
              :default-value="editDialog.form.exChangeAgent||''"
              :method-params="{bookingAgent:true,active:true}"
              @parentCallBack="p=>{onExChangeAgentChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultAgent" no="defaultAgent">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.AgentInfo')" />
          <el-form-item
            v-for="count in 7"
            :key="'addressLine'+count"
            label-width="0"
          >
            <el-input
              :ref="'addressLine'+count"
              v-model="editDialog.form['addressLine'+count]"
              :no="'addressLine'+count"
              :filter-chars="false"
              style="width:300px"
              @dblclick.native="showBlAddressDialog"
              @change="()=>wrapAddr(editDialog.form,'addressLine'+count,count+1 > 7 ? null :'blAddressLine'+(count+1),maxChars)"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import cargoInput from '@/components/Cargo/Common/cargoInput.vue'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect'
import { getCompanyListByType4Cache } from '@/api/company'

export default {
  name: 'ExchangeAgentForm',
  components: { CargoOwnedBranchSelect, CargoCompanySelect, CargoRichTextarea, cargoInput, cargoAdvanceSelect, cargoUserSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedRow: null,
      selectTypeNames: TYPE_NAMES,
      form: {},
      filter: {
        overseaAgentUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: p => { this.selectedRow = p.data }
      },
      exChangeAgentList: [],
      agentList: [],
      companyList: [],
      deleteExChangeAgentKeys: [],
      editDialog: {
        visible: false,
        title: '',
        form: {}
      },
      autoIncrementNum: new AutoIncrementNum(),
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0, autoUppercase: false, autoHalfWord: false
        }
      },
      maxChars: 255,
      company: {}
    }
  },
  computed: {
    currentOfficeList() {
      return this.$store.state.user.userInfo.currentUserOfficeList
    },
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    readonly() {
      return !this.isEdit
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('baseInfo.partner.chineseName'),
          field: 'chineseName',
          width: 200,
          cellRenderer: params => {
            if (!params.data || !params.data.exChangeAgent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.exChangeAgent, 'chineseName')
          },
          tooltipValueGetter: (params) => {
            if (!params.data || !params.data.exChangeAgent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.exChangeAgent, 'chineseName')
          }
        }, {
          headerName: this.$t('baseInfo.partner.englishName'),
          field: 'englishName',
          width: 200,
          cellRenderer: params => {
            if (!params.data || !params.data.exChangeAgent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.exChangeAgent, 'englishName')
          },
          tooltipValueGetter: (params) => {
            if (!params.data || !params.data.exChangeAgent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.exChangeAgent, 'englishName')
          }
        },
        {
          headerName: this.$t('baseInfo.partner.shortName'),
          field: 'shortName',
          width: 100,
          cellRenderer: params => {
            if (!params.data || !params.data.exChangeAgent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.exChangeAgent, 'shortName')
          },
          tooltipValueGetter: (params) => {
            if (!params.data || !params.data.exChangeAgent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.exChangeAgent, 'shortName')
          }
        },
        {
          headerName: this.$t('baseInfo.partner.cnShortName'),
          field: 'cnShortName',
          width: 100,
          cellRenderer: params => {
            if (!params.data || !params.data.exChangeAgent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.exChangeAgent, 'cnShortName')
          },
          tooltipValueGetter: (params) => {
            if (!params.data || !params.data.exChangeAgent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.exChangeAgent, 'cnShortName')
          }
        }, {
          headerName: this.$t('baseInfo.partner.branchId'),
          field: 'multipleBranchId',
          width: 150,
          cellRenderer: (params) => {
            if (params.value) {
              const values = params.value.split(',')
              const names = []
              for (const val of values) {
                if (val === '0') {
                  names.push(this.$t('Message.All'))
                } else {
                  names.push(ColumnUtils.getOfficeLabel('officeId', Number(val)))
                }
              }
              return names.join(',')
            }
            return ''
          }
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultAgent',
          width: 100,
          cellRenderer: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        }, {
          headerName: this.$t('SeaExport.AgentInfo'),
          field: 'agentInfo',
          width: 200,
          cellRenderer: params => {
            const agent = params.data
            if (!agent) return ''
            return agent.addressLine1 + '<br/>' + agent.addressLine2 + '<br/>' + agent.addressLine3 + '<br/>' + agent.addressLine4 +
              '<br/>' + agent.addressLine5 + '<br/>' + agent.addressLine6 + '<br/>' + agent.addressLine7
          },
          tooltipValueGetter: (params) => {
            const agent = params.data
            if (!agent) return ''
            return agent.addressLine1 + '<br/>' + agent.addressLine2 + '<br/>' + agent.addressLine3 + '<br/>' + agent.addressLine4 +
              '<br/>' + agent.addressLine5 + '<br/>' + agent.addressLine6 + '<br/>' + agent.addressLine7
          }
        }
      ]
    }
  },
  created() {
    // 获取所有有效
    getCompanyListByType4Cache({ type: 'bookingAgent', active: true }).then(res => {
      this.companyList = res.data.list
    })
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.company = row
        this.exChangeAgentList = row.exChangeAgentList || []
        if (this.exChangeAgentList && this.exChangeAgentList.length > 0) {
          this.exChangeAgentList.forEach(p => {
            p.seq = this.autoIncrementNum.getNextNum()
          })
        }
        this.deleteExChangeAgentKeys = []
      }
    },
    getSubmitData() {
      return {
        exChangeAgentList: this.exChangeAgentList,
        deleteExChangeAgentKeys: this.deleteExChangeAgentKeys
      }
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          multipleBranchId: '1',
          exChangeAgent: 0,
          defaultAgent: false,
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          addressLine5: '',
          addressLine6: '',
          addressLine7: '',
          companyUuid: this.company.uuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        // 第一个新增的默认为是，允许修改
        if (this.exChangeAgentList.length === 0) {
          this.editDialog.form.defaultAgent = true
        } else {
          let hasDefault = false
          for (const agent of this.exChangeAgentList) {
            if (agent.defaultAgent) {
              hasDefault = true
              break
            }
          }
          this.editDialog.form.defaultAgent = !hasDefault
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const row = this.selectedRow
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.initAgentList()
      this.editDialog.visible = true
    },
    save() {
      if (!this.editDialog.form.multipleBranchId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BranchCMP') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.editDialog.form.exChangeAgent) {
        this.$message.warning(this.$t('SeaExport.BillExchangeAgent') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      // 判断当前的换单代理列表中已经有的重复的换单代理（分公司+换单代理 唯一），提示错误：已有重复的的换单代理!
      for (const agent of this.exChangeAgentList) {
        // 判断换单代理
        if (Number(this.editDialog.form.exChangeAgent) === Number(agent.exChangeAgent)) {
          // 判断分公司
          const curBranchIds = this.editDialog.form.multipleBranchId.split(',') || []
          const hisBranchIds = agent.multipleBranchId.split(',') || []
          if (curBranchIds.length > 0 && hisBranchIds.length > 0) {
            for (const hisBranchId of hisBranchIds) {
              for (const curBranchId of curBranchIds) {
                if (Number(hisBranchId) === Number(curBranchId) && this.editDialog.form.uuid !== agent.uuid) {
                  this.$message.warning(this.$t('SeaExport.BillExchangeAgent') + this.$t('CargoMsg.Cargo_CanNotRepeat'))
                  return
                }
              }
            }
          }
        }
      }
      const row = this.exChangeAgentList.find(item => item.seq === this.editDialog.form.seq)
      if (row) {
        Object.assign(row, this.editDialog.form)
        this.gridApi.refreshCells({ force: true })
      } else {
        if (!this.editDialog.form.uuid) {
          this.exChangeAgentList.push(this.editDialog.form)
        }
      }
      this.editDialog.visible = false
    },
    remove() {
      const self = this
      const row = this.selectedRow
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.exChangeAgentList.findIndex(p => p.seq === row.seq)
        if (index !== -1) {
          this.exChangeAgentList.splice(index, 1)
          if (row.uuid) {
            this.deleteExChangeAgentKeys.push(row.uuid)
          }
        }
      }).catch(() => { })
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    showBlAddressDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.AgentInfo'), this.mergeBlAddressLine(), this.splitBlAddressLine, false, {
        maxChar: 255, autoUppercase: true, autoHalfWord: true
      })
    },
    splitBlAddressLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.editDialog.form['addressLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.editDialog.form['addressLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.editDialog.form['addressLine' + i] = ''
      }
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    mergeBlAddressLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.editDialog.form['addressLine' + i] || ''
        result += '\n'
      }
      result += (this.editDialog.form['addressLine7'] || '')
      return result.trimEnd()
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(arr) {
      if (arr && arr.length > 0) {
        return arr.join(',')
      }
      return ''
    },
    onExChangeAgentChange(data) {
      this.editDialog.form.exChangeAgent = data.value
    },
    multipleBranchIdChange() {
      this.editDialog.form.exChangeAgent = 0
      this.initAgentList()
    },
    initAgentList() {
      // 根据分公司进行过滤
      this.agentList = []
      if (this.companyList.length > 0 && this.editDialog.form.multipleBranchId) {
        const branchIds = this.editDialog.form.multipleBranchId.split(',')
        for (const item of this.companyList) {
          for (const branchId of branchIds) {
            if (Number(branchId) === item.branchId || Number(branchId) === 1) {
              this.agentList.push(item)
              break
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>
